import theme from 'src/libs/styled-components/theme';
import { IconProps } from '..';

export default function IconSearch({
  width = 20,
  height = 20,
  color = theme.palette.grayscale300
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.16675 10.8333H4.16675V9.16666H9.16675V4.16666H10.8334V9.16666H15.8334V10.8333H10.8334V15.8333H9.16675V10.8333Z"
        fill={color}
      />
    </svg>
  );
}
